import React from "react";
import style from './UnlockingPotentialCard2.module.css';

export default function UnlockingPotentialCard2(props) {

    return (
        <div 
            data-aos="fade-right"
            data-aos-duration="1000"
            className={style.card}
        >
            <div className={style.div3}>
                <img src={props.image} alt="img" />
            </div>
            <div className={style.div2}>
                {props.sno}
            </div>
            <div className={style.div1}>
                <p>{props.heading}</p>
                <p>{props.content}</p>
            </div>
        </div>
    )
}